import DataUtilities from './data-utilities';

export default DataUtilities;
